<template>
<div class="chapter">
<div class="inner_page">
<div class="sgc-toc-title">
    Table of Contents
  </div>
<div class="sgc-toc-level-1">
<span href="#/Text/9781611532630#_idParaDest-1" title="Link target outside of Sample">Title Page</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/97816115326301#_idParaDest-2" title="Link target outside of Sample">Copyright</span>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/TOC">Contents</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/97816115326302#_idParaDest-3">Dedication</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/97816115326303#_idParaDest-4">Infamous</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/97816115326304#_idParaDest-5">chapter 1 Iowa</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/97816115326305#_idParaDest-6">chapter 2 Sunshine</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/97816115326306#_idParaDest-7">chapter 3 Bur Oak</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/97816115326307#_idParaDest-8">chapter 4 New Year’s Eve</a>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/97816115326308#_idParaDest-9" title="Link target outside of Sample">chapter 5 Fayetteville or Bust</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/97816115326309#_idParaDest-10" title="Link target outside of Sample">chapter 6 M.A. Hopkins</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/978161153263010#_idParaDest-11" title="Link target outside of Sample">chapter 7 First Day</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/978161153263011#_idParaDest-12" title="Link target outside of Sample">chapter 8 Go-Kart</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/978161153263012#_idParaDest-13" title="Link target outside of Sample">chapter 9 Converging Coordinate Planes</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/978161153263013#_idParaDest-14" title="Link target outside of Sample">chapter 10 Stenos and Strippers</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/978161153263014#_idParaDest-15" title="Link target outside of Sample">chapter 11 Apologies</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/978161153263015#_idParaDest-16" title="Link target outside of Sample">chapter 12 Blond Hair, Blue Eyes</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/978161153263016#_idParaDest-17" title="Link target outside of Sample">chapter 13 Sizzle</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/978161153263017#_idParaDest-18" title="Link target outside of Sample">chapter 14 Steppin’ Out</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/978161153263018#_idParaDest-19" title="Link target outside of Sample">chapter 15 Hair Apparent</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/978161153263019#_idParaDest-20" title="Link target outside of Sample">chapter 16 Hindsight</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/978161153263020#_idParaDest-21" title="Link target outside of Sample">chapter 17 Infamous</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/978161153263021#_idParaDest-22" title="Link target outside of Sample">chapter 18 Check Canopy</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/978161153263022#_idParaDest-23" title="Link target outside of Sample">chapter 19 Kings and Queens</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/978161153263023#_idParaDest-24" title="Link target outside of Sample">chapter 20 Corn Rows</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/978161153263024#_idParaDest-25" title="Link target outside of Sample">chapter 21 Purple Coneflower Boutonniere</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/978161153263025#_idParaDest-26" title="Link target outside of Sample">chapter 22 Smothered and Covered</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/978161153263026#_idParaDest-27" title="Link target outside of Sample">chapter 23 Heathcliff and Catherine</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/978161153263027#_idParaDest-28" title="Link target outside of Sample">chapter 24 Zugzwang</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/978161153263028#_idParaDest-29" title="Link target outside of Sample">chapter 25 Soul Food</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/978161153263029#_idParaDest-30" title="Link target outside of Sample">chapter 26 Coming and Going</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/978161153263030#_idParaDest-31" title="Link target outside of Sample">chapter 27 Let Freedom Ring</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/978161153263031#_idParaDest-32" title="Link target outside of Sample">chapter 28 Promises, Promises</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/978161153263032#_idParaDest-33" title="Link target outside of Sample">Chapter 29 Love Makes the World Go ‘Round</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/978161153263033#_idParaDest-34" title="Link target outside of Sample">Chapter 30 Unexpected Visitor</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/978161153263034#_idParaDest-35" title="Link target outside of Sample">Chapter 31 Goodbyes</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/978161153263035#_idParaDest-36" title="Link target outside of Sample">Chapter 32 New Beginnings</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/978161153263036#_idParaDest-37" title="Link target outside of Sample">A Note to Readers from Amalie Jahn</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/978161153263037#_idParaDest-38" title="Link target outside of Sample">Acknowledgments</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/978161153263038#_idParaDest-39" title="Link target outside of Sample">About the Author</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/978161153263039#_idParaDest-40" title="Link target outside of Sample">If You Liked This Book You Might Also Like</span>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// TOC.vue?d14f46b8